import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AbstractComponent } from '../util/abstract.component';
import { SessaoService } from '../services/sessao.service';
import { EnderecoService } from '../services/endereco.service';
import { MensagemService } from '../services/mensagem.service';
import { RestClientService } from '../services/restclient.service';
import { Contrato } from '../modelo/contrato';
import { Cliente } from '../modelo/cliente';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

declare var $: any;

@Component({
  selector: 'app-endereco-selecao',
  templateUrl: './endereco-selecao.component.html',
  styleUrls: ['./endereco.component.css'],
  providers: [EnderecoService, MensagemService, RestClientService]
})
export class EnderecoSelecaoComponent extends AbstractComponent implements OnInit {

  cliente: Cliente = new Cliente();

  constructor(
    private sessaoService: SessaoService,
    private enderecoService: EnderecoService,
    private mensagemService: MensagemService,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService) {
    super(sessaoService);
  }

  /**
   * Método chamado na inicialização
   */
  ngOnInit() {
    // Menu
    $(".btsMenu .btn").removeClass("active activeDrop");
    $(".atualizar").addClass("active");

    //Scroll top
    window.scrollTo(0, 0);

    sessionStorage.setItem("veioSegundaViaCarne", "N");

    this.buscaContratos();

    // Close Menu Mobile
    var isMobile = window.matchMedia("only screen and (max-width: 760px)");
    $(".content").click(function() {
      if (isMobile.matches) {
        $(".page").removeClass("toggled");
      }
    });
  }

  /**
   * Retorna a lista de contratos
   */
  buscaContratos = (): void => {
    this.enderecoService.listarContrato().subscribe(
      (result: Cliente) => {
        if (result.cdMsgemRetorno === '1007') {
          this.sair();
        } else {
          this.cliente = result;
        }
      },
      (error: Response) => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  /**
   * Redireciona para o detalhamento do contrato selecionado
   * @param contrato
   */
  onClickContrato(contrato: Contrato) {
    sessionStorage.setItem('enderecoContrato', JSON.stringify(contrato.endereco));
    sessionStorage.setItem('contrato', JSON.stringify(contrato));
    sessionStorage.setItem('veioSegundaViaCarne', 'N');
    this.router.navigate(['/BF-Portal/enderecoDados']);
  }

  /**
   * Efetua o logout do sistema e redireciona para o autoline
   */
  sair() {
    sessionStorage.removeItem("sessao");
    sessionStorage.clear();
    this.sessaoService.sessao.logado = false;
    this.router.navigate(['/redirecionamento']);
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-endereco-cli/endereco-selecao.component.ts